import axios from 'axios';
import { Message } from 'element-ui';
import { operate401 } from '@/utils/request';

function adAssetBaseURL() {
  let raw = String(process.env.VUE_APP_AD_ASSET_API || '').trim();
  if (
    (raw.startsWith("'") && raw.endsWith("'")) ||
    (raw.startsWith('"') && raw.endsWith('"'))
  ) {
    raw = raw.slice(1, -1).trim();
  }
  return raw;
}

const service = axios.create({
  baseURL: adAssetBaseURL(),
  timeout: 20000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

function colaMessage(payload) {
  if (!payload || typeof payload !== 'object') {
    return '';
  }
  if (
    payload.errCode === 'B_FB_ACCOUNT_NOT_FOUND' ||
    payload.errCode === 'B_GOOGLE_ACCOUNT_NOT_FOUND' ||
    payload.errCode === 'ACCOUNT_NOT_FOUND'
  ) {
    return '该账户尚未同步到新资产管理，请先在新资产管理导入后再充值';
  }
  if (payload.errCode === 'NO_PERMISSION') {
    return '当前角色无充值权限，请到新资产管理处理或联系家族助理';
  }
  return payload.errMessage || payload.message || '';
}

service.interceptors.request.use(
  (config) => {
    const saToken = localStorage.getItem('saToken') || '';
    if (saToken) {
      config.headers.saToken = saToken;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res && (res.code == 401 || res.code === '401')) {
      operate401();
      return Promise.reject(res);
    }
    if (res && typeof res.success === 'boolean' && !res.success) {
      Message.error(colaMessage(res) || '操作失败');
      return Promise.reject(res);
    }
    return res;
  },
  (error) => {
    const status = error.response && error.response.status;
    const data = error.response && error.response.data;
    if (status === 401 || (data && (data.code == 401 || data.code === '401'))) {
      operate401();
      return Promise.reject(error);
    }
    Message.error(colaMessage(data) || error.message || '请求失败');
    return Promise.reject(error);
  },
);

export function normalizeActId(raw) {
  if (raw == null) {
    return '';
  }
  let id = String(raw).trim().replace(/-/g, '');
  if (id.toLowerCase().startsWith('act_')) {
    id = id.slice(4);
  }
  return id;
}

export function getBillOwnershipsForRecharge(params) {
  return service.get('/api/dropdown/bill-ownerships-for-recharge', { params });
}

export function applyFbRecharge(data) {
  return service.post('/api/fb/account-finance/recharge/apply', data);
}

export function normalizeGoogleAccountId(raw) {
  if (raw == null) {
    return '';
  }
  return String(raw).trim().replace(/-/g, '');
}

export function getGoogleRechargeAccountInfo(accountId) {
  return service.get('/api/google/recharge/account-info', {
    params: { accountId },
  });
}

export function applyGoogleRecharge(data) {
  return service.post('/api/google/recharge', data);
}
